export default "__VITE_ASSET__BEI4ak8w__"